
if (!customElements.get('intersection-loader')) {
  class IntersectionLoader extends HTMLElement {
    constructor() {
      super();

      this.url = this.dataset.url;
      this.sectionId = this.dataset.sectionId || false;
      this.objectId = this.dataset.objectId || false;
      this.position = this.dataset.position || false;
    }

    connectedCallback() {
      if (!this.sectionId) return;

      if (!this.hasChildNodes()) {
        this.classList.add('loader-wrapper');
        this.innerHTML = `
        <div>
          Loading...
        </div>
      `;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.loadFromAPI().then(() => this.observer.unobserve(this));
            }
          })
        },
        { rootMargin: '0px', threshold: 0.1 }
      );
      this.observer.observe(this);
    }

    async loadFromAPI() {
      const url = new URL(this.url, window.location.origin);
      const searchParams = new URLSearchParams(url.search);
      searchParams.set('section_id', this.sectionId);
      const urlToFetch = `${url.origin.toString()}${url.pathname.toString()}?${searchParams.toString()}`;

      fetch(urlToFetch)
        .then((response) => response.text())
        .then((text) => {
          const temp = document.createElement('div');
          const newNode = document.createElement('div');

          temp.innerHTML = text;
          newNode.innerHTML = temp?.querySelector(`#shopify-section-${this.sectionId}`)?.innerHTML ?? '';

          if (!newNode.innerHTML) {
            console.warn(`No content found for section ${this.sectionId}`);
            this.innerHTML = '<div>Content not available</div>';
            return;
          }

          [...newNode.children].forEach(child => {
            if (this.objectId && this.position) {
              child.dataset.objectId = this.objectId;
              child.dataset.position = this.position;
            }
            this.before(child);
          });

          this.remove();
        }).catch((error) => {
          console.error('Failed to load content:', error);
          this.innerHTML = '<div>Failed to load content</div>';
          this.classList.add('error');
        });

    }
  }

  customElements.define('intersection-loader', IntersectionLoader);
}